import script from "./SlotFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotFilters.vue?vue&type=script&setup=true&lang=js"

import "./SlotFilters.vue?vue&type=style&index=0&id=38f2b041&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38f2b041"]])

export default __exports__